import { render, staticRenderFns } from "./View.vue?vue&type=template&id=2f45806f&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "./View.vue?vue&type=style&index=0&id=2f45806f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45806f",
  null
  
)

export default component.exports